import * as t from '../actionTypes';

export const openEditMyAccountModal = () => ({
  type: t.OPEN_EDIT_ACCOUNT_MODAL
});

export const closeEditMyAccountModal = () => ({
  type: t.CLOSE_EDIT_ACCOUNT_MODAL
});
